/**
 * Tiny wrapper around `window.confirm` so destructive buttons across the
 * UI surface a consistent message format. Returns a stable callback (no
 * closure capture problems) that fires only if the user confirms.
 *
 *   const confirm = useConfirm();
 *   onClick={() => confirm('clear all stale transactions', () => clearStale())}
 *
 * Messages render as `This will <action>. Continue?`. Plain
 * `window.confirm` for now — a richer in-app dialog can plug in later
 * by swapping the implementation behind this hook.
 */
import { useCallback } from 'react';

export type ConfirmFn = (action: string, onConfirm: () => void) => void;

export function useConfirm(): ConfirmFn {
  return useCallback((action: string, onConfirm: () => void) => {
    if (typeof window === 'undefined') {
      onConfirm();
      return;
    }
    if (window.confirm(`This will ${action}. Continue?`)) {
      onConfirm();
    }
  }, []);
}
